import { All as Other } from '../All'
import { ArtMaterial } from '../ArtMaterial'
import { Bag } from '../Bag'
import { Book as Library } from '../Book'
import { Bookstore } from '../Bookstore'
import { Castle as PatrimonyTourism } from '../Castle'
import { ChemistryTools as ScientificCulture } from '../ChemistryTools'
import { Cinema as Movie } from '../Cinema'
import { CulturalCentre as CulturalCentre } from '../CulturalCentre'
import { Digital } from '../Digital'
import { Festival } from '../Festival'
import { Landscape as VisualArt } from '../Landscape'
import { Museum } from '../Museum'
import { Opera } from '../Opera'
import { PerformingArts } from '../PerformingArts'
import { Piano as MusicalInstrumentStore } from '../Piano'
import { Store } from '../Store'
import { Turntable as RecordStore } from '../Turntable'
import { VideoGame as Games } from '../VideoGame'

export const venueTypesIcons = {
  ArtMaterial,
  Bag,
  Bookstore,
  CulturalCentre,
  Digital,
  Festival,
  Games,
  Library,
  Movie,
  Museum,
  MusicalInstrumentStore,
  Opera,
  Other,
  PatrimonyTourism,
  PerformingArts,
  RecordStore,
  ScientificCulture,
  Store,
  VisualArt,
}
